import { Component, OnInit,Renderer, ElementRef, ViewChild } from '@angular/core';
//import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { AutoWidthCalculator } from 'ag-grid';
import {GridOptions} from "ag-grid/main";
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from "rxjs/Observable";
import { BootstrapDatePickerComponent } from '../shared/components/ng-date-picker.component';
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { CommonUtility, Announcement, AnnouncementSummary, WpPerson,VIEW_BTN, AgGridUtility } from '../shared';
import { DataService, MIN_CHAR_SEARCH_LENGTH, AuthService, DateUtility } from '../shared';
import {ReferenceTableService} from '../reference-table.service';
import {ProviderService} from "../provider-management/provider-management.service";
import { NotificationsService } from 'angular2-notifications';

interface JQuery {
  datepicker(options?: any, callback?: Function) : any;
}
@Component({
  selector: 'app-admin-provider-county',
  templateUrl: './admin-provider-county.component.html',
  styleUrls: ['./admin-provider-county.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AdminProviderCountyComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText:ElementRef;
  gridApi;

  firstTime: Boolean = true;
  isAddNew: Boolean = false;
  gridColumnApi;
  rowData: any;
  tabIndex:any = "-1";
  tabIndex1:any = "-1";
  columnDefs;
  newCount:any =1;
  components:any;
  frameworkComponents:any;
  counties:any = [];
  isAddDisable:Boolean;
  countyKey:any;
  countyName:any;
  provider:any;
  rowSelection:any = "multiple";
  initialData:any;
  removeCounties: any =[];
  gridOptions;
  isChangeDetected:boolean = false;
  isSave:Boolean = false;

  tabToNextCell:any;

  constructor(public dataService:DataService, private router:Router, private authService: AuthService,
              private data: ReferenceTableService,
              private providerService:ProviderService,
              private notificationService: NotificationsService,
              private dateUtil:DateUtility,
              private modalPopupService: ModalPopupService,
              private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.columnDefs = [
      {
        headerName: "County",
        editable: params => params.data.check === true,
        field: "county",
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: this.counties
        },
        onCellValueChanged: (params) => {
          // const that = params.context.componentParent;
          // that.isChangeDetected = true;
        }
      },
      {
        headerName: "Service Begin Date",
        field: "startDate",
        editable: params => params.data.check1 === true,
        cellEditor: "datePicker",
        onCellValueChanged: (params) => {
          // const that = params.context.componentParent;
          // that.isChangeDetected = true;
        }
      },
      {
        headerName: "Service End Date",
        field: "endDate",
        editable: true,
        cellEditor: "datePicker",
        onCellValueChanged: (params) => {
          // const that = params.context.componentParent; 
          // that.isChangeDetected = true;
        }
      }
    ];



    // this.components = { datePicker: this.getDatePicker(), datePicker2: this.getDatePicker2() };
    this.frameworkComponents = {
      datePicker: BootstrapDatePickerComponent,
    };
    this.gridOptions = <GridOptions>{
      context: {
        componentParent: this
      }

    };
    if(this.dataService.getSharedDataObject().get("ADPSH") == undefined){
      this.router.navigate(['/admin/provider-management']);
    }
  }

  ngOnInit() {
    this.dataService.globalAccess = true;
    this.dataService.removeValueFromSharedDataMap('counties');
    for(let i=0; i<this.data.getValueFromSharedDataMap('COUNTIES').length;i++){
      this.counties.push(this.data.getValueFromSharedDataMap('COUNTIES')[i].name);
    }
    if(this.dataService.getSharedDataObject().get("provider") == undefined){
      this.isAddDisable = true;
      this.tabIndex = "0";
    }
    else{
      this.isAddDisable = false;
      let id = this.dataService.getSharedDataObject().get("provider").id
      this.provider = this.dataService.getSharedDataObject().get("provider");
      console.log(this.provider);
      this.providerService.getcountyDetails(id).subscribe((data)=>{
        this.dataService.addValueToSharedDataMap('counties',data);
        this.rowData = [];
        this.initialData = [];
        for(let i=0;i<data.length;i++){
          this.getname(data[i].serviceCounty);
          this.provider = data[i].provider;
          this.counties = this.counties.filter(item => item!== this.countyName);
          this.initialData.push({
            county:this.countyName,
            startDate:this.dateUtil.convertFormattedDateFromServer(data[i].serviceBeginDt),
            endDate:this.dateUtil.convertFormattedDateFromServer(data[i].serviceEndDt),
            check:false,
            check1:false,
            prostartDate: this.dateUtil.convertFormattedDateFromServer(this.dataService.getSharedDataObject().get("provider").providerBeginDt),
            proendDate: this.dateUtil.convertFormattedDateFromServer(this.dataService.getSharedDataObject().get("provider").providerEndDt)
          });
          this.rowData.push({
            county:this.countyName,
            startDate:this.dateUtil.convertFormattedDateFromServer(data[i].serviceBeginDt),
            endDate:this.dateUtil.convertFormattedDateFromServer(data[i].serviceEndDt),
            id:data[i].id,
            recordVersion:data[i].recordVersion,
            check: false,
            check1:false,
            prostartDate: this.dateUtil.convertFormattedDateFromServer(this.dataService.getSharedDataObject().get("provider").providerBeginDt),
            proendDate: this.dateUtil.convertFormattedDateFromServer(this.dataService.getSharedDataObject().get("provider").providerEndDt)
          })
        }
      })
    }
  }
  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      //this.gridOptions.columnDefs = this.columnDefs;
      //console.log("Hello");
    }
    else{
      this.gridApi.sizeColumnsToFit();
    }
  }
  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  onAddRow() {
    var newItem = this.createNewRowData();
    var res = this.gridApi.updateRowData({ add: [newItem] });
    console.log(this.gridColumnApi.getColumn("county"));
    this.firstTime = false;
    this.isAddNew = true;

    let index;
    res.add.forEach(element => {
      index = element.rowIndex;
    });
    this.gridApi.setFocusedCell(index, "county");
    this.gridApi.startEditingCell({
      rowIndex: index,
      colKey: "county"
    });
    this.gridApi.paginationGoToPage( Math.floor(index / 10) );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setRowData(this.rowData);
    params.api.setGridAutoHeight(true);
  }
  createNewRowData() {
    var newData = {
      county: "Pick An Option",
      startDate: "mm/dd/yyyy",
      endDate: "mm/dd/yyyy",
      check:true,
      check1:true,
      prostartDate:this.dateUtil.convertFormattedDateFromServer(this.dataService.getSharedDataObject().get("provider").providerBeginDt),
      proendDate: this.dateUtil.convertFormattedDateFromServer(this.dataService.getSharedDataObject().get("provider").providerEndDt)
    };
    this.rowData.push(newData);
    if(this.rowData[this.rowData.length-2] !== undefined){
      this.counties = this.counties.filter(item => item!== this.rowData[this.rowData.length-2].county);
    }
    let col = this.gridColumnApi.getColumn("county");
    let colDef = col.getColDef();
    colDef.cellEditorParams.values = this.counties;
    this.gridApi.refreshHeader();
    return newData;
  }
  reset(){
    this.gridApi.setRowData(this.initialData);
  }
  getDatePicker() {
    function Datepicker() {}
    Datepicker.prototype.init = function(params) {
      this.eInput = document.createElement("input");
      this.eInput.value = params.value;
      //console.log(params.node.data);
      ($(this.eInput) as any).datepicker({ dateFormat: "mm/dd/yy",
        minDate: params.node.data.prostartDate,
        maxDate: params.node.data.proendDate });
    };
    Datepicker.prototype.getGui = function() {
      return this.eInput;
    };
    Datepicker.prototype.afterGuiAttached = function() {
      this.eInput.focus();
      this.eInput.select();
    };
    Datepicker.prototype.getValue = function() {
      return this.eInput.value;
    };
    Datepicker.prototype.destroy = function() {};
    Datepicker.prototype.isPopup = function() {
      return false;
    };
    return Datepicker;
  }
  getDatePicker2() {
    function Datepicker() {}
    Datepicker.prototype.init = function(params) {
      this.eInput = document.createElement("input");
      this.eInput.value = params.value;
      //console.log(params.node.data);
      ($(this.eInput) as any).datepicker({ dateFormat: "mm/dd/yy",
        minDate: params.node.data.startDate,
        maxDate: params.node.data.proendDate });
    };
    Datepicker.prototype.getGui = function() {
      return this.eInput;
    };
    Datepicker.prototype.afterGuiAttached = function() {
      this.eInput.focus();
      this.eInput.select();
    };
    Datepicker.prototype.getValue = function() {
      return this.eInput.value;
    };
    Datepicker.prototype.destroy = function() {};
    Datepicker.prototype.isPopup = function() {
      return false;
    };
    return Datepicker;
  }
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };
  save(){
    this.isSave = true;
    this.gridApi.stopEditing();
    //console.log(this.gridApi.getRowData());
    let token = this.dataService.getSharedDataObject().get("token");
    let data = [];
    let error = 0;
    this.initialData.forEach((opt,i) =>this.rowData.forEach((opt2,j)=>{
      if((opt.county === opt2.county) && (opt.startDate === opt2.startDate) && (opt.endDate === opt2.endDate)){
        console.log(opt2.startDate);
        console.log(opt.startDate);
        console.log("Hello");
      }
      else if(i===j){
        this.getvalue(this.rowData[i].county);
        data.push({
          id:this.rowData[i].id,
          recordVersion:this.rowData[i].recordVersion,
          provider:this.provider,
          serviceBeginDt: this.dateUtil.convertFormattedDateForServer(this.rowData[i].startDate),
          serviceEndDt: this.dateUtil.convertFormattedDateForServer(this.rowData[i].endDate),
          serviceCounty: this.countyKey
        })
      }

    }));
    for(let i=this.initialData.length; i<this.rowData.length;i++){
      //console.log(this.rowData[i].county);
      if((this.rowData[i].county == "Pick An Option") || (this.rowData[i].county == "Pick an option") ){
        //this.notificationService.error('County Name is mandatory for Assigning Provide County');
        error += 1;
      }
      else{
        this.getvalue(this.rowData[i].county);
        data.push({
          provider:this.provider,
          serviceBeginDt: this.dateUtil.convertFormattedDateForServer(this.rowData[i].startDate),
          serviceEndDt: this.dateUtil.convertFormattedDateForServer(this.rowData[i].endDate),
          serviceCounty: this.countyKey
        })
      }
    }
    console.log(data);
    for(let i=0; i< data.length; i++){
      if(data[i].serviceEndDt === "yyyy/mm/dd"){
        data[i].serviceEndDt = null;
      }
    }
    this.providerService.saveCountyDetails(token,data).subscribe((data)=>{
      console.log(data);
      if(data.length>=1){
        this.isChangeDetected = false;
        this.notificationService.success('Assign Provider County saved successfully');
        this.ngOnInit();
        this.isSave = false;
      }
      else{
        if(error === 0){
          this.notificationService.error('Service begin date is mandatory for Assigning Provide County');
        }
        else if(error>0){
          this.notificationService.error('County Name is mandatory for Assigning Provide County');
        }
        else{
          this.notificationService.error('System Error:Please contact Help Desk');
        }
        this.isSave = false;
      }
    })
  }
  getvalue(key){
    for(let i=0; i<this.data.getValueFromSharedDataMap('COUNTIES').length; i++){
      if(this.data.getValueFromSharedDataMap('COUNTIES')[i].name == key){
        this.countyKey = this.data.getValueFromSharedDataMap('COUNTIES')[i].value;
      }
    }
  }
  getname(key){
    for(let i=0; i<this.data.getValueFromSharedDataMap('COUNTIES').length; i++){
      if(this.data.getValueFromSharedDataMap('COUNTIES')[i].value == key){
        this.countyName = this.data.getValueFromSharedDataMap('COUNTIES')[i].name;
      }
    }
  }

  focusSummary(e: KeyboardEvent) {
    this.isAddNew = false;
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }

    if(this.rowData.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }


  setDisplayedRowAtIndex() {
    // get the first row

    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode =  this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  setDisplayedRowAtAddNew() {
    var index = this.rowData.length;
    var rowNode =  this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index + 1, firstCol);

    this.gridApi.paginationGoToPage( Math.floor(index / 10) );
    this.isAddNew = false;
  }

  onPaginationChanged(event) {
    if (this.gridApi ) {
      if (this.isAddNew) {
        return;
      } else if( this.firstTime ){
        return;
      } else{
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }


}





// WEBPACK FOOTER //
// ./src/app/admin-provider-county/admin-provider-county.component.ts